import { theme } from '../theme';

function NotificationModal({ notifications, onClose }) {
  if (!notifications || notifications.length === 0) return null;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0,0,0,0.7)',
      zIndex: 10000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem',
    }}>
      <div style={{
        backgroundColor: theme.colors.surface,
        border: `1px solid ${theme.colors.primary}`,
        borderRadius: '14px',
        width: '100%',
        maxWidth: '500px',
        maxHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: `0 8px 32px ${theme.colors.glowStrong}`,
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '1.2rem 1.5rem',
          borderBottom: `1px solid ${theme.colors.border}`,
          flexShrink: 0,
        }}>
          <span style={{ color: theme.colors.primary, fontWeight: '700', fontSize: '1rem' }}>
            📢 Avisos de hoy
          </span>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: theme.colors.textMuted,
              cursor: 'pointer',
              fontSize: '1.3rem',
              lineHeight: 1,
              padding: '0 2px',
            }}
          >
            ✕
          </button>
        </div>
        <div style={{ overflowY: 'auto', padding: '1.2rem 1.5rem', flex: 1 }}>
          {notifications.map((n, i) => (
            <div
              key={i}
              style={{
                marginBottom: i < notifications.length - 1 ? '1.5rem' : 0,
                paddingBottom: i < notifications.length - 1 ? '1.5rem' : 0,
                borderBottom: i < notifications.length - 1 ? `1px solid ${theme.colors.border}` : 'none',
              }}
            >
              <p style={{
                color: theme.colors.primary,
                fontWeight: '700',
                fontSize: '0.95rem',
                margin: '0 0 0.4rem 0',
              }}>
                {n.title}
              </p>
              <p style={{
                color: theme.colors.text,
                fontSize: '0.9rem',
                lineHeight: '1.6',
                margin: 0,
              }}>
                {n.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default NotificationModal;
